import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayers32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLayers32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M24.471 11.291 15.975 7l-8.497 4.291 8.497 4.291zm-7.595-6.076a2 2 0 0 0-1.803 0L4.809 10.399a1 1 0 0 0 0 1.785l10.264 5.184a2 2 0 0 0 1.803 0l10.264-5.184a1 1 0 0 0 0-1.785zm-12.77 9.973a1 1 0 0 1 1.341-.447l10.528 5.263 10.527-5.263a1 1 0 1 1 .894 1.789l-10.974 5.487-.447.223-.448-.223L4.553 16.53a1 1 0 0 1-.447-1.342m1.341 3.897a1 1 0 1 0-.894 1.789l10.974 5.487.448.223.447-.223 10.974-5.487a1 1 0 1 0-.894-1.79l-10.527 5.264z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayers32);
